import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Component, Inject } from '@angular/core';

@Component({
  selector: 'app-notification',
  template: `<h1 matDialogTitle class="mb-8">{{ data.title }}</h1>
    <div mat-dialog-content class="mb-16">{{ data.message }}</div>
    <div mat-dialog-actions class="pb-16 ">
    <button
    type="button"
    mat-raised-button
    class="full-width"
    color="primary"
    (click)="dialogRef.close(true)">Aceptar</button>
    &nbsp;
    <span fxFlex></span>
    </div>`,
})
export class AppNotificationComponent {
  constructor(
    public dialogRef: MatDialogRef<AppNotificationComponent>,
    @Inject(MAT_DIALOG_DATA) public data:any
  ) {}
}
